<script>
	import { QSpinner } from 'quasar';

	export default {
		extends: QSpinner
	};
</script>
